import { __require as requireShim } from "../vendor/use-sync-external-store/shim/index.js";
var shimExports = requireShim();
export {
  shimExports as s
};
//# sourceMappingURL=index.js.map
